import { render } from "./App.vue?vue&type=template&id=6c7ea950"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__